// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel */


(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        current_position: 0,
        active_level_filters: [],
        active_area_of_expertise_filters: [],
        active_search_string: '',

        /**
         * Initialise theme JS on page load
         */
        init: () => {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Clear all class filters
         */
        __clearClassFilters: () => {
            wntrTheme.body.find('.class__clear-filters').on('click', function() {
                clearFilters();
            });

            function clearFilters() {
                // Reset search
                wntrTheme.body.find('.class-search__form input[type=search]').val('');
                wntrTheme.body.find('.classes').removeClass('classes--search-filters-active');
                wntrTheme.body.find('.class').removeClass('search-active');

                // Reset checkboxes
                wntrTheme.body.find('.classes').removeClass('classes--filters-active');
                wntrTheme.body.find('.class').removeClass('active');
                wntrTheme.body.find('.class-filter input[type="checkbox"]').removeAttr('checked');
                wntrTheme.active_level_filters = [];
                wntrTheme.active_area_of_expertise_filters = [];

                // Reset history state
                window.history.pushState({}, '', wntrTheme.body.find('.page-section-class').data('url'));

                // Reset number of classes
                const number_of_classes = wntrTheme.body.find('.class:visible').length;
                wntrTheme.body.find('.class__count-visible').html(number_of_classes);
            }
        },

        /**
         * Sort classes by date
         */
        __sortClassesByDate: () => {
            wntrTheme.body.find('#date').on('change', function() {
                const order = $(this).val();
                const class_wrapper = wntrTheme.body.find('.class__wrapper');

                class_wrapper.removeClass('class__wrapper--desc class__wrapper--asc');
                class_wrapper.addClass('class__wrapper--' + order);

                // Everything is done bya JS, so we need to fake a spinner for the user to understand that something happened.. 👻
                wntrTheme.body.find('.classes').addClass('classes--loading');
                setTimeout(function() {
                    wntrTheme.body.find('.classes').removeClass('classes--loading');
                }, 500);
            });
        },

        /**
         * Filter classes by text search
         */
        __filterClassesByTextSearch: () => {
            wntrTheme.body.find('.class-search__form').on('submit', function(e) {
                e.preventDefault();
                const search_text = $(this).find('input[type=search]').val().toLowerCase();
                wntrTheme.active_search_string = encodeURIComponent(search_text);

                // Everything is done bya JS, so we need to fake a spinner for the user to understand that something happened.. 👻
                wntrTheme.body.find('.classes').addClass('classes--loading');
                setTimeout(function() {
                    wntrTheme.body.find('.classes').removeClass('classes--loading');
                }, 500);

                wntrTheme.handleTextSearchFilters(search_text);
                wntrTheme.addToHistoryState();
            });
        },

        // Handle checkbox filters
        handleTextSearchFilters: (search_text) => {
            const classes = wntrTheme.body.find('.class');

            if (search_text.length > 2) {
                wntrTheme.body.find('.class-search__error').removeClass('active');
                wntrTheme.body.find('.classes').addClass('classes--search-filters-active');
                wntrTheme.body.find('.class').removeClass('search-active');

                $.each(classes, function() {
                    const heading = $(this).find('.class__heading h2').html().toLowerCase();

                    if (heading.indexOf(search_text) !== -1) {
                        $(this).addClass('search-active');
                    }
                });
            } else if (search_text.length === 0) {
                wntrTheme.body.find('.class-search__error').removeClass('active');
                wntrTheme.body.find('.classes').removeClass('classes--search-filters-active');
            } else {
                wntrTheme.body.find('.class-search__error').addClass('active');
                wntrTheme.body.find('.classes').removeClass('classes--search-filters-active');
            }

            // Count classes to display
            const number_of_classes = wntrTheme.body.find('.class:visible').length;
            wntrTheme.body.find('.class__count-visible').html(number_of_classes);
        },

        /**
         * Filter classes by terms
         */
        __filterClassesByTerms: () => {
            // Filter Levels
            wntrTheme.body.find('.class-filter__level input[type="checkbox"]').on('click', function() {
                const $cb = $(this);
                if ($cb.is(':checked')) {
                    wntrTheme.active_level_filters.push($cb.val());
                } else {
                    const index = wntrTheme.active_level_filters.indexOf($cb.val());
                    wntrTheme.active_level_filters.splice(index, 1);
                }

                wntrTheme.body.find('.classes').addClass('classes--loading');
                setTimeout(function() {
                    wntrTheme.body.find('.classes').removeClass('classes--loading');
                }, 500);

                wntrTheme.handleCheckboxFilters();
                wntrTheme.addToHistoryState();
            });

            // Filter Areas of Expertise
            wntrTheme.body.find('.class-filter__area-of-expertise input[type="checkbox"]').on('click', function() {
                const $cb = $(this);
                if ($cb.is(':checked')) {
                    wntrTheme.active_area_of_expertise_filters.push($cb.val());
                } else {
                    const index = wntrTheme.active_area_of_expertise_filters.indexOf($cb.val());
                    wntrTheme.active_area_of_expertise_filters.splice(index, 1);
                }

                wntrTheme.body.find('.classes').addClass('classes--loading');
                setTimeout(function() {
                    wntrTheme.body.find('.classes').removeClass('classes--loading');
                }, 500);

                wntrTheme.handleCheckboxFilters();
                wntrTheme.addToHistoryState();
            });
        },

        // Handle checkbox filters
        handleCheckboxFilters: () => {
            // Check if any filters are active
            const is_active_filters = (wntrTheme.active_level_filters === undefined || wntrTheme.active_level_filters.length === 0) && (wntrTheme.active_area_of_expertise_filters === undefined || wntrTheme.active_area_of_expertise_filters.length === 0);
            if (is_active_filters) {
                wntrTheme.body.find('.classes').removeClass('classes--filters-active');
            } else {
                wntrTheme.body.find('.classes').addClass('classes--filters-active');
            }

            // Remove the active classes before adding them again
            wntrTheme.body.find('.class').removeClass('active');

            // Filter levels
            wntrTheme.active_level_filters.forEach(function(level) {
                if (wntrTheme.active_area_of_expertise_filters.length > 0) {
                    wntrTheme.active_area_of_expertise_filters.forEach(function(expertise) {
                        wntrTheme.body.find('.class[data-area-of-expertise=' + expertise + '][data-level=' + level + ']').addClass('active');
                    });
                } else {
                    wntrTheme.body.find('.class[data-level=' + level + ']').addClass('active');
                }
            });

            // Filter the area of expertises
            wntrTheme.active_area_of_expertise_filters.forEach(function(expertise) {
                if (wntrTheme.active_level_filters.length > 0) {
                    wntrTheme.active_level_filters.forEach(function(level) {
                        wntrTheme.body.find('.class[data-area-of-expertise=' + expertise + '][data-level=' + level + ']').addClass('active');
                    });
                } else {
                    wntrTheme.body.find('.class[data-area-of-expertise=' + expertise + ']').addClass('active');
                }
            });

            // Count classes to display
            const number_of_classes = wntrTheme.body.find('.class:visible').length;
            wntrTheme.body.find('.class__count-visible').html(number_of_classes);
        },

        /**
         * Apply history state
         */
        __applyHistoryState: () => {
            const level = getUrlParameter('level');
            const expertise = getUrlParameter('expertise');
            const search_query = getUrlParameter('search_query');

            if (level) {
                wntrTheme.active_level_filters = level.split(',');
                wntrTheme.active_level_filters.forEach(function(item) {
                    wntrTheme.body.find('.class-filter__level input#' + item).attr('checked', 'checked').prop('checked', 'checked');
                });
                wntrTheme.handleCheckboxFilters();
            }

            if (expertise) {
                wntrTheme.active_area_of_expertise_filters = expertise.split(',');
                wntrTheme.active_area_of_expertise_filters.forEach(function(item) {
                    wntrTheme.body.find('.class-filter__area-of-expertise input#' + item).attr('checked', 'checked').prop('checked', 'checked');
                });
                wntrTheme.handleCheckboxFilters();
            }

            if (search_query) {
                const decoded_text_string = decodeURIComponent(search_query);
                wntrTheme.active_search_string = decoded_text_string;
                wntrTheme.body.find('.class-search__form input[type=search]').val(decoded_text_string);
                wntrTheme.handleTextSearchFilters(decoded_text_string);
            }

            function getUrlParameter(sParam) {
                const sPageURL = window.location.search.substring(1);
                const sURLVariables = sPageURL.split('&');
                let sParameterName;
                let i;
                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                    }
                }
            }
        },

        /**
         * Add to history state
         */
        addToHistoryState: () => {
            let url = wntrTheme.body.find('.page-section-class').data('url');

            if (wntrTheme.active_level_filters.length > 0) {
                url = url + '?level=' + wntrTheme.active_level_filters.join();
            }

            if (wntrTheme.active_area_of_expertise_filters.length > 0) {
                if (wntrTheme.active_level_filters.length > 0) {
                    url = url + '&expertise=' + wntrTheme.active_area_of_expertise_filters.join();
                } else {
                    url = url + '?expertise=' + wntrTheme.active_area_of_expertise_filters.join();
                }
            }

            if (wntrTheme.active_search_string.length > 0) {
                if (wntrTheme.active_level_filters.length > 0 || wntrTheme.active_area_of_expertise_filters.length > 0) {
                    url = url + '&search_query=' + wntrTheme.active_search_string;
                } else {
                    url = url + '?search_query=' + encodeURIComponent(wntrTheme.active_search_string);
                }
            }

            window.history.pushState({}, '', url);
        },

        /**
         * Check if mouse is used
         */
        __checkIfMouseIsUsed: () => {
            // Let the document know when the mouse is being used
            document.body.addEventListener('mousedown', function() {
                document.body.classList.add('using-mouse');
            });
            // Re-enable focus styling when Tab is pressed
            document.body.addEventListener('keydown', function(event) {
                if (event.keyCode === 9) {
                    document.body.classList.remove('using-mouse');
                }
            });
        },

        /**
         * Toggle header background color on scroll
         */
        __toggleHeaderBackground: () => {
            let scrollTimeout = null;
            const throttle = 50;

            toggleHeaderBackgroundClass();

            // Simple scroll throttle
            $(window).on('scroll', function () {
                if (!scrollTimeout) {
                    scrollTimeout = setTimeout(function () {
                        toggleHeaderBackgroundClass();
                        scrollTimeout = null;
                    }, throttle);
                }
            });

            function toggleHeaderBackgroundClass() {
                const scroll = $(window).scrollTop();
                if (scroll >= 15) {
                    wntrTheme.body.addClass('header--solid');
                } else {
                    wntrTheme.body.removeClass('header--solid');
                }
            }
        },

        /**
         * Toggle header
         */
        __toggleHeader: () => {
            // Toggle main header
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');

            toggleHeaderButton.on('click', function() {
                if (wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    $(this).removeClass('is-active');
                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    $(this).addClass('is-active');

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if (e.keyCode === 27 && wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                }
            });

            // Toggle sub menu
            if ($(window).width() < 1100) {
                const toggleSubMenuButton = wntrTheme.body.find('.header__toggle-sub-menu');

                toggleSubMenuButton.on('click', function() {
                    const btn = $(this);
                    btn.toggleClass('is--active');
                    btn.closest('.menu-item-has-children').find('.sub-menu').slideToggle('fast');
                });

                // Check if we're on an subpage
                const active_sub_menu = wntrTheme.body.find('li.active .sub-menu');
                if (active_sub_menu.length > 0) {
                    active_sub_menu.closest('.menu-item-has-children').find('.header__toggle-sub-menu').addClass('is--active');
                    active_sub_menu.css('display', 'block');
                }
            } else {
                const hover_submenu_item = wntrTheme.body.find('li.menu-item-has-children');
                wntrTheme.body.find('.header__toggle-sub-menu').attr('tabindex', '-1');

                hover_submenu_item.on('mouseover', function() {
                    $(this).addClass('header--submenu-active');
                });

                hover_submenu_item.on('mouseout', function() {
                    $(this).removeClass('header--submenu-active');
                });

                wntrTheme.body.find('li.menu-item-has-children > a').on('focus', function() {
                    $(this).closest('.menu-item').addClass('header--submenu-active');
                });

                wntrTheme.body.find('.sub-menu li:last-of-type > a').on('keydown', function(event) {
                    if (event.shiftKey && event.keyCode === 9) {
                        $(this).closest('.menu-item').addClass('header--submenu-active');
                    } else if (event.keyCode === 9) {
                        $(this).closest('.menu-item').removeClass('header--submenu-active');
                    }
                });
            }
        },

        /**
         * Toggle search
         */
        __toggleHeaderSearch: () => {
            const toggleSearchBtn = wntrTheme.body.find('.header__search-btn');

            toggleSearchBtn.on('click', function() {
                wntrTheme.body.toggleClass('header--search-active');
                if (wntrTheme.body.hasClass('header--search-active')) {
                    wntrTheme.body.find('.header__search input[type=search]').focus();
                }
            });

            $(document).keyup(function(e) {
                if (e.keyCode === 27 && wntrTheme.body.hasClass('header--search-active')) {
                    wntrTheme.body.removeClass('header--search-active');
                }
            });
        },

        /**
         * Match height
         */
        __doMatchHeight: () => {
            wntrTheme.body.find('.puff__text').matchHeight();
            wntrTheme.body.find('.puff__heading').matchHeight();
            wntrTheme.body.find('.card__heading > h2').matchHeight();
            wntrTheme.body.find('.bulletin-board__preamble').matchHeight();
        },

        /**
         * Handorgel Accordions
         */
        __handorgelAccordions: () => {
            if (wntrTheme.body.find('.handorgel-facilities').length > 0) {
                const accordion_facilities = wntrTheme.body.find('.handorgel-facilities');

                accordion_facilities.each(function(index, el) {
                    const accordion = new handorgel(el, {});

                    accordion.on('fold:open', (fold) => {
                        const slider = $(fold.button).closest('.handorgel__header').next().find('.facilities__gallery');

                        if (slider.length > 0) {
                            slider.slick("slickNext");
                            accordion.update();
                        }
                    });

                    accordion.on('fold:opened', (fold) => {
                        fold.content.style.height = 'auto';
                    });
                });
            }

            if (wntrTheme.body.find('.handorgel').length > 0) {
                const accordions = wntrTheme.body.find('.handorgel');
                accordions.each(function(index, el) {
                    new handorgel(el, {});
                });
            }
        },

        /**
        * Facilites slider
        */
        __facilitesSlider: () => {
            wntrTheme.body.find('.facilities__gallery').slick({
                'dots': false
            });
        },

        /**
         * Global search spinner
         */
        __addSpinnerToGlobalSearch: () => {
            wntrTheme.body.find('.header__search form').on('submit', function() {
                $(this).find('.header-search__submit').addClass('header-search__submit--loading');
            });
        }
    };

    $(document).ready(wntrTheme.init);
})(jQuery);